import CustomerUsersProvider from './CustomerUsersContext';
import CustomerUsers from './CustomerUsers';

let Index = () => {
    return (
        <CustomerUsersProvider>
            <CustomerUsers />
        </CustomerUsersProvider>
    )
}

export default Index;